import styled from 'styled-components';

export const ProductFormWrapper = styled.form``;
